<template>
  <div class="news-container">
    <!-- <page-top></page-top> -->
    <div class="content_wrap">
      <myImg img="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_6.png"></myImg>
      <my-tab :tab-list="tabList" @change="changeTab" :activeIndex="activeIndex" :bread-title="breadTitle" smallSize>
      </my-tab>
      <div class="news_list_box container" v-if="activeIndex == 1 && showList">
        <b-container v-if="newsList.length > 0">
          <b-row>
            <b-col md="6" lg="4" v-for="(v, i) in newsList" :key="i" @click="checkDetail(i,v)">
              <div class="news_list_box_item mt-40">
                <div class="img_mask">
                  <div>
                    <i class="el-icon-search"></i>
                  </div>
                  <img :src="v.img" class="item_img" height="230px" :alt="v.alt" />
                </div>

                <div class="mt-20 color-fff fs-20 text-overflow">
                  {{ v.title }}
                </div>
                <span>{{ v.date }}</span>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <div class="container text-center color-ccc mt-30 fs-30 empty-tip" v-else>
          {{ $t("public.nomore") }}
        </div>
        <!-- <el-pagination
          background
          layout="prev, pager, next"
          :total="10"
          @@pagination="_getList"
        ></el-pagination> -->
      </div>
      <template v-if="activeIndex == 2">
        <div class="fs-24 mt-40 mb-40">{{ $t("public.nomore") }}</div>
      </template>
      <div class="news_notice container" v-if="activeIndex == 0 && showList">
        <!-- <h2>暂无相关内容</h2> -->
        <b-container>
          <b-row v-if="noticeList.length>0">
            <b-col md="6" lg="4" v-for="(v, i) in noticeList" :key="i" @click="checkDetail(i,v)">
              <div class="news_list_box_item mt-40" v-if="i < 9">
                <div class="img_mask">
                  <div>
                    <i class="el-icon-search"></i>
                  </div>
                  <img :src="v.img" class="item_img" height="230px" :alt="v.alt" />
                </div>

                <div class="mt-20 color-fff fs-20 text-overflow">
                  {{ v.title }}
                </div>
                <span>{{ v.date }}</span>
              </div>
            </b-col>
          </b-row>
          <div class="container text-center color-ccc mt-30 fs-30 empty-tip" v-else>
            {{ $t("public.nomore") }}
          </div>
        </b-container>
      </div>
      <div class="detail_wrap container" v-if="detailFlag">
        <h1 class="mt-20 mb-20 color-fff fs-30 text-center" v-if="
          activeIndex == 1
            ? newsList[curIndex].showTitle
            : noticeList[curIndex].showTitle
        ">
          {{
            activeIndex == 1
              ? newsList[curIndex].title
              : noticeList[curIndex].title
          }}
        </h1>
        <div v-html="activeIndex == 1
            ? newsList[curIndex].detail
            : noticeList[curIndex].detail
          "></div>
      </div>
    </div>
    <!-- <page-bottom></page-bottom> -->
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
// import pageBottom from "@/components/pageBottom";
import myTab from "@/components/myTab";
import myImg from "@/components/myImg";
import pageFooter from "@/components/pageFooter";
import merge from "webpack-merge";
export default {
  components: {
    pageTop,
    myImg,
    // pageBottom,
    myTab,
    pageFooter,
  },
  created() { },
  mounted() {
    this.changeTabs(this.tabs);
    // this.changeCurs(this.curs);
  },
  data() {
    return {
      tabList: [
        {
          title: this.$t("newscenter.notice"),
          en: "Notice",
        },
        {
          title: this.$t("newscenter.news"),
          en: "News",
        },
      ],
      breadTitle: {
        cn: this.$t("newscenter.title"),
        en: "News Center",
      },
      tabs: this.$route.query.tab,
      curs: this.$route.query.cur,
      newsId: this.$route.query.newsId ? this.$route.query.newsId : "",
      noticeId: this.$route.query.noticeId ? this.$route.query.noticeId : "",
      activeIndex: 0,
      detailFlag: false,
      showList: true,
      curIndex: undefined,
      noticeList: [
        //       {
        //         id:10,
        //           title:'温馨提示：广州国际车展最后一天展览结束时间延长至下午17:30',
        //           img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
        //           date:'2024-11-23',
        //           detail:`<span class="text-center">温馨提示：广州国际车展最后一天展览结束时间延长至下午17:30</span><br>
        // <i class="text_indent_2"></i>广州国际车展于今天迎来公众日的周末，现场人山人海，展会盛况空前。明天（11月24日）将是本届车展最后一天，按原计划展会将于当天下午16:30结束展览。<br>
        // <i class="text_indent_2"></i>为回应广大观众的热情，满足观众的参观需求，组委会特将最后一天的展览时间延长1小时，让观众有更多时间参与本届广州国际车展，体验汽车新科技，感受美好新生活！<br>
        // <i class="text_indent_2"></i><p class="text-center">11月24日展览时间调整为</p><br>
        // <i class="text_indent_2"></i><span class="text-center">9:30——17:30</span>`
        //       },
        //       {
        //         id:11,
        //           title:'媒体接待中心11月19日起将移至广交会展馆A区',
        //           img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
        //           date:'2024-11-18',
        //           detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/notice/captrue/notice_11.png' alt/>`
        //       },
        //         {
        //           id: 9,
        //           title: "第二十三届广州国际汽车展览会媒体注册通知",
        //           img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
        //           date: "2024-11-02",
        //           detail: `<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/21.png' alt/>`,
        //         },
      ],
      newsList: [
        {
          id: 'mp01',
          title:'2024广州国际车展圆满闭幕 | 2025广州国际车展将于2025年11月21日至30日举办',
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
          date: "2024-11-24",
          url:"https://mp.weixin.qq.com/s/mOE-docGqi54MK2OT-Ckpg"
        },
        {
          id: 41,
          title: "2024广州汽车发展高峰论坛圆满落幕",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c40.jpeg",
          date: "2024-11-17",
          detail: `<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/40.png' alt/>`,
        },
        {
          id: 40,
          title: "携手合作 赋能创新—2024汽车创新大会在广州开幕",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c41.png",
          date: "2024-11-17",
          detail: `<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/41.png' alt/>`,
        },
        {
          id: 42,
          title: "聚焦高端化、智能化、绿色化︱2024物流与运输车辆高峰论坛广州召开",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c35.webp",
          date: "2024-11-17",
          detail: `<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/39.png' alt/>`,
        },
        {
          id: 39,
          title: "谋新质，开新局，广州汽车发展高峰论坛盛大开幕",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c40.jpeg",
          date: "2024-11-15",
          detail: `<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/42.png' alt/>`,
        },

        {
          id: 38,
          title:
            this._i18n.locale == "zh"
              ? "把握行业脉搏、探求发展新格局 \n 2024广州汽车发展高峰论坛11月开启"
              : "Seizing Industry Trends, Exploring New Growth Patterns: 2024 Guangzhou Auto Industry Development Summit Kicks Off in November",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
          date: "2024-11-06",
          // detail:this._i18n.locale == "en"? this.tempszh : this.tempseen,
          detail:
            this._i18n.locale == "zh"
              ? `<i class='text_indent_2'></i>2024年11月15至16日，在第22届广州国际汽车展览会开幕期间，由中国国际贸易促进委员会汽车行业委员会、中国对外贸易中心联合主办的“2024广州汽车发展高峰论坛”将于广交会展馆广交会堂举行。<br><i class='text_indent_2'></i>当前，全球汽车工业正在经历着百年来最为深刻的根本性变革。汽车的新能源化、智能网联化发展趋势如火如荼，汽车的内涵和外延日益拓展，中国也从全球最大的汽车市场转变为全球汽车产业变革最大的推动力量。<br><i class='text_indent_2'></i>近年来，在广州国际汽车展览开幕期间，作为唯一官方论坛，我们多次举办了这一高规格、高品质的产业发展论坛。在去年广州论坛上，聚焦汽车产业普遍关注，来自行业各个领域的多位重量级嘉宾参与演讲互动，他们的精彩观点体现了对国内外汽车工业发展的深刻洞悉，为与会者带来了一场场别开生面的行业盛宴。论坛期间，会场座无虚席，现场报道的主流媒体近百家，参与直播的媒体超过50家，总点击量接近一千万。综合各方反馈，该论坛的话题设置精准契合行业诉求，演讲嘉宾代表了业内最高水准，高质量的内容得到了线下、线上与会者的一致肯定<br>
                <i class='text_indent_2'></i><div>今年，论坛主题定为<span class='bold'>“谋新质、开新局”</span>。作为年终盘点，我们将聚焦规范行业竞争、强化品牌建设、促进供应链打造、增进产业赋能、推进汽车出海等行业焦点课题，广邀传统车企、行业专家、科技企业、海外商务及产业代表团等齐聚一堂，以各自独特的视角纵论汽车行业热点问题，共同探讨激发新质生产力、开启产业新局面</div>
                <i class='text-indent_2'></i><div><span class='bold'>2024广州汽车发展高峰论坛</span>欢迎业界同仁的莅临，也欢迎所有关心汽车工业发展的朋友的到来，让我们共同为世界汽车工业的健康发展献策献力、携手推动中国汽车产业迈上更高台阶！<div><img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/newsContent/38/zh.jpg'>`
              : `<i class='text_indent_2'></i>Hosted by the China Council for the Promotion of International Trade, Automotive Sub-Council, and China Foreign Trade Centre, the "2024 Guangzhou Auto Industry Development Summit" will take place at the Guangzhou Convention and Exhibition Center from November 15th to 16th, coinciding with the opening of the 22nd Guangzhou International Automobile Exhibition.<br>
                <i class='text_indent_2'></i>The global automotive industry is undergoing the most substantial transformation in a century. With each passing day, the concept and role of automobiles are evolving due to the advancements in new energy and intelligent connectivity. China has transitioned from the world's largest automotive market to the primary driving force behind the global automotive industry’s transformation.<br>
                <i class='text_indent_2'></i>Over the past few years, during the Guangzhou International Automobile Exhibition, we have consistently held this high-standard, high-quality industrial development forum as the only official forum. At last year’s Guangzhou Forum, we addressed major issues of concern to the automotive industry and invited many distinguished guests to join the discussions. These guests shared insightful perspectives on both domestic and international developments, creating a unique and enriching experience for participants. The forum was a success, with nearly 100 mainstream media outlets reporting on-site, over 50 media participating in the live broadcast, and a total of nearly 10 million views. Considering feedback from all parties, the forum's topics accurately addressed industry demands. The speakers were top-tier, and the high-quality content received praise from both offline and online participants.<br>
                <i class='text_indent_2'></i><div>This year’s theme is <span class='bold'>“Unleashing New-Quality Productivity, Opening New Horizons”</span>. As a year-end review, we will focus on crucial industry topics, including fair industry competition, strengthening brand building, enhancing supply chain development, increasing industrial support, and promoting the international expansion of Chinese automobiles. Traditional car makers, new EV manufacturers, industry experts, high-tech companies, and delegations from overseas are invited to share their unique perspectives. They will provide insights into how the auto industry can stimulate new quality productivity and create a new landscape in the industry.</div>
                <i class='text_indent_2'></i><div>The <span class='bold'>2024 Guangzhou Auto Industry Development Summit</span> invites industry peers and enthusiasts to join us. Together, let’s contribute to the healthy development of the global automotive industry and propel China’s automobile industry to new heights!</div><img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/newsContent/38/en.jpg'>`,
          showTitle: true,
        },
        {
          id: 37,
          title: "整车厂& Tier1 &汽车电子产业链1v1创新产品技术对接会",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4_c.jpg",
          date: "2024-11-01",
          detail: `<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/37.png' alt/>`,
        },
        {
          id: 36,
          title:
            this._i18n.locale == "zh"
              ? "新科技·新生活！第二十三届广州国际汽车展览会将于2024年11月15日至24日在广交会展馆盛大举办"
              : "New Tech, New Life!The 22nd Guangzhou International Automobile Exhibition to be grandly held from November 15 to 24, 2024, at the Canton Fair Complex",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4.jpg",
          date: "2024-09-13",
          // detail:this._i18n.locale == "en"? this.tempszh : this.tempseen,
          detail:
            this._i18n.locale == "zh"
              ? `扬帆启航开新局，团结奋进谱新篇。广州国际汽车展览会（以下简称“广州国际车展”），自2003年创办以来，始终秉承“新科技·新生活”的主题理念，以为汽车行业打造高品质、国际化、综合性的展览体验平台为宗旨，与行业精英携手并进，砥砺前行，共同见证了中国汽车产业的发展与成长，参与了世界汽车工业的革新与重塑。<br>
<i class="text_indent_2"></i>第二十三届广州国际汽车展览会将于2024年11月15日至24日，在中国进出口商品交易会展馆盛大举办（以下简称“广交会展馆”）。本届展会规划使用广交会展馆A区、D区以及两区的室外展区，展会规模将创历史新高。<br>
<i class="text_indent_2"></i>本届车展吸引了国际汽车行业的目光，全球主流车企将以最高规格亮相广州国际车展。来自全球的整车企业将集中登录广州国际车展乘用车展区，为全球观众带来最新汽车科技产品；同期同馆的广州国际商用车展览会贴合新质生产力发展要求，展品全面覆盖智能化卡车、氢能及换电重卡、新能源物流车辆、轻量化厢式车、冷链运输车、皮卡改装专用车及各类房车；汽车产业链及汽车文化展区由原广州国际车展汽车零部件及用品展区升级而来，顺应汽车产业电动化、智能化发展新方向，规划了电机电控、充电储能、自动驾驶、智能座舱、生态互联、人工智能等新题材。广州国际车展三大展区形成完整的新时代汽车全产业链，着力发展汽车产业新质生产力，助力汽车行业形成高质量发展新格局。<br>
<i class="text_indent_2"></i>展会期间，还将同期举办多场汽车产业高峰论坛、沙龙及行业研讨会，来自政府部门、全球汽车行业、国际科技巨头及关联产业新锐、领军人物、专家学者等齐聚一堂，以各自独特的视角纵论全球行业发展大势、构建产业发展共同体、促进产业融合、加速汽车行业转型升级、为全球汽车行业可持续发展增添新动能。<br>
<i class="text_indent_2"></i>我们诚邀全球车企及汽车爱好者共襄盛举，共享前沿新科技，共创美好新生活。`
              : `The Guangzhou International Automobile Exhibition (AUTO GUANGZHOU) has adhered to the theme of “New Tech, New Life” since its inception in 2003.The event has always aimed to provide a high-quality exhibition platform for the international automotive industry. Over the years, it has closely collaborated with industry elites, advancing together with them while witnessing the development of China's automotive sector and participating in the transformation of global automotive industry.<br>
<i class="text_indent_2"></i>The AUTO GUANGZHOU 2024 will be grandly held from November 15 to 24, 2024, at the Canton Fair Complex. The AUTO GUANGZHOU 2024 will utilize Areas A and D of the Canton Fair Complex, including the outdoor spaces of the two areas, marking the largest show in the event’s history.<br>
<i class="text_indent_2"></i>The AUTO GUANGZHOU 2024 has captured the attention of the global automotive industry, with leading car manufacturers from around the world showcasing their innovations at the event. International vehicle manufacturers will gather in the Passenger Car Area, presenting the latest automotive technologies to a global audience. Simultaneously, the Guangzhou International Commercial Vehicle Exhibition, to be held in the same venue, will serve the development of new-quality productive forces. Exhibits will cover a wide range of products, including intelligent trucks, hydrogen-powered and battery-swappable heavy trucks, new energy logistics vehicles, lightweight vans, cold chain transport trucks, customized pickup trucks, and various RVs. The Automobile Industrial Chain & Automobile Culture Area, upgraded from the former Auto Parts and Accessories section, reflects the latest trends in electrification and intelligent automotive technologies. The exhibits will feature innovations in electric motors and controllers, charging and energy storage systems, autonomous driving, smart cockpits, connected ecosystems, artificial intelligence, and other new themes. Together, these three main exhibition areas form a complete ecosystem for the modern automotive industry, focusing on developing new-quality productive forces and driving the sector toward high-quality growth.<br>
<i class="text_indent_2"></i>During the event, multiple automotive industry summits, salons, and seminars will take place. Representatives from government, global automotive sector, international technology giants, emerging industry leaders, and academic experts will gather to share their unique insights. They will discuss the major trends shaping the global automotive industry, explore ways to build an industrial development community, promote cross-industry integration, accelerate the transformation and upgrading of the automotive sector, and contribute to the sustainable development of the global automotive industry.<br>
<i class="text_indent_2"></i>We cordially invite automotive enterprises and enthusiasts from around the world to join us in this grand event, share cutting-edge automotive technologies, and create a better future together.`,
        },
        {
          id: 35,
          title: "2024第六届广州国际商用车展览会11月举办",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c35.webp",
          date: "2024-04-01",
          detail: `<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/35.png' alt/>`,
        },
        {
          id: 34,
          title: "2024广州国际车展汽车产业链及汽车文化展区11月举办",
          img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner4_c.jpg",
          date: "2023-05-31",
          detail: `<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/34.jpg' alt/>`,
        },
        // {
        //   id:35,
        //   title:'2024第六届广州国际商用车展览会11月举办',
        //   img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c35.webp",
        //   date:'2024-04-01',
        //   detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/35.png' alt/>`
        // },
        // {
        //   id:33,
        //   title:'2023广州车展圆满闭幕，第二十三届将于2024年11月15日至24日举办',
        //   img: "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/c28.jpeg",
        //   date:'2023-11-26',
        //   detail:`<img src='https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/news/img/news_all/28.png' alt/>`
        // }
      ],
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.tab != from.query.tab) {
        this.changeTabs(to.query.tab);
      }
    },
  },
  methods: {
    changeTabs(index) {
      let that = this;
      that.activeIndex = index;
      if (that.curs) {
        that.curIndex = that.curs;
        that.detailFlag = true;
        that.showList = false;
        that.$router.replace({
          query: merge(
            {},
            {
              tab: that.activeIndex,
              cur: that.curs,
            }
          ),
        });
      }      
      if (this.newsId) {
        this.newsList.map((item, index) => {
          console.log(item);

          if (this.newsId == item.id) {
            console.log(index);
            that.checkDetail(index,item);
            return;
          }
        });
      } else if (this.noticeId) {
        this.noticeList.map((item, index) => {
          if (this.noticeId == item.id) {
            // console.log(index);
            that.checkDetail(index,item);
            return;
          }
        });
      }
    },
    _getList() { },
    checkDetail(index,value) {
      // 判断是否是字符串
      if (typeof value.id == 'string') {
        window.open(value.url, '_blank')
      }else{
        this.curIndex = index;
      this.detailFlag = true;
      this.showList = false;
      this.$router.replace({
        query: merge(
          {},
          {
            tab: this.activeIndex,
            cur: this.curIndex,
          }
        ),
      });
      }
      
      
    },
    changeTab(index) {
      this.activeIndex = index;
      this.detailFlag = false;
      this.showList = true;
      // console.log(this.activeIndex, this.showList);
    },
  },
};
</script>

<style lang="scss">
.news-container {
  width: 100vw;
  background: #221f26;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  cursor: default;
  min-height: 100vh;
  justify-content: space-between;

  .content_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .son-page {
    width: 1920px;
    height: 300px;
    background-image: url("https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_6.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .menu_wrap {
    width: 1200px;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;

    .news_wrap {
      height: 100px;
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
      box-sizing: border-box;
      display: flex;

      >div {
        font-size: 30px;
        // width: 143px;
        line-height: 100px;
        text-align: center;
        color: #ccc;
        border-bottom: 2px solid transparent;
        margin-right: 50px;
      }

      .act-item {
        color: #42abff;
        border-bottom: 1px solid #42abff;
      }
    }

    .right_wrap {
      display: flex;
      color: rgba(255, 255, 255, 0.8);
      align-items: center;
    }
  }

  .news_list_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;

    .news_list_wrap {
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;

      .news_item_card {
        display: flex;
        flex-direction: column;
        margin-bottom: 89px;
        width: 370px;

        // margin-right: 50px;
        .news_img {
          width: 370px;
          height: 260px;
          margin-bottom: 26px;
          position: relative;

          >img {
            width: 370px;
            height: 260px;
          }

          >div {
            visibility: hidden;
            position: absolute;
            width: 100%;
            height: 260px;
            background: rgba($color: #000000, $alpha: 0.5);
            display: flex;
            flex-direction: column;
            justify-content: center;

            >i {
              color: #fff;
              font-size: 50px;
              margin: 0 auto;
            }
          }
        }

        .news_img:hover {
          >div {
            visibility: visible;
          }
        }

        >h2 {
          width: 352px;
          // height: 22px;
          line-height: 40px;
          font-size: 22px;
          color: #ffffff;
          margin: 0;
        }

        .news_desc {
          width: 358px;
          max-height: 120px;
          font-size: 20px;
          color: #cccccc;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          line-height: 40px;
        }

        >span {
          // width: 81px;
          // height: 12px;
          line-height: 60px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }

    .news_list_box_item {
      .img_mask {
        position: relative;

        >div {
          visibility: hidden;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;

          >i {
            color: #fff;
            font-size: 50px;
            margin: 0 auto;
          }
        }
      }

      .img_mask:hover {
        >div {
          visibility: visible;
        }
      }
    }
  }

  .news_notice {
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;

    .notice_list_wrap {
      // width: 1200px;
      width: 100%;
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;

      .notice_item_card {
        display: flex;
        flex-direction: column;
        margin-bottom: 89px;
        width: 470px;
        margin-right: 50px;

        .notice_img {
          width: 470px;
          height: 260px;
          margin-bottom: 26px;
          position: relative;

          >img {
            width: 470px;
            height: 260px;
          }

          >div {
            visibility: hidden;
            position: absolute;
            width: 470px;
            height: 260px;
            background: rgba($color: #000000, $alpha: 0.5);
            display: flex;
            flex-direction: column;
            justify-content: center;

            >i {
              color: #fff;
              font-size: 50px;
              margin: 0 auto;
            }
          }
        }

        .notice_img:hover {
          >div {
            visibility: visible;
          }
        }

        >h2 {
          width: 352px;
          // height: 22px;
          line-height: 40px;
          font-size: 22px;
          color: #ffffff;
          margin: 0;
        }

        .notice_desc {
          width: 358px;
          max-height: 120px;
          font-size: 20px;
          color: #cccccc;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 40px;
        }

        >span {
          // width: 81px;
          // height: 12px;
          line-height: 50px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }

    .news_list_box_item {
      .img_mask {
        position: relative;

        >div {
          visibility: hidden;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba($color: #000000, $alpha: 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;

          >i {
            color: #fff;
            font-size: 50px;
            margin: 0 auto;
          }
        }
      }

      .img_mask:hover {
        >div {
          visibility: visible;
        }
      }
    }
  }

  .detail_wrap {
    margin: 100px 0px;
    font-size: 24px;
    line-height: 40px;
    text-indent: 48px;

    >div {
      display: flex;
      flex-direction: column;

      >h2 {
        text-align: center;
        color: #fff;
        font-size: 30px;
      }

      .detail_date {
        text-align: center;
        color: #ccc;
        margin-bottom: 56px;
        font-size: 20px;
        margin: 20px;
      }

      .detail_title {
        color: #42abff;
        font-size: 20px;
        margin-bottom: 53px;
      }

      .detail_desc {
        font-size: 20px;
        color: #ccc;
        text-indent: 50px;
        margin-bottom: 40px;
      }

      .text_right {
        text-align: right;
      }

      >img {
        margin: 50px 0px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .news-container {
    .menu_wrap {
      width: 100vw;
      height: 200px;
      justify-content: center;

      .news_wrap {
        // width: 100%;
      }

      .right_wrap {
        display: none;
      }
    }

    .news_list_box {
      display: flex;
      flex-direction: column;
      align-items: center;

      .news_list_wrap {
        width: 100vw;
        padding: 0px 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .news_item_card {
          display: flex;
          flex-direction: column;
          margin-bottom: 89px;
          width: 46vw;

          .news_img {
            width: 100%;
            height: 520px;
            margin-bottom: 26px;
            position: relative;

            >img {
              width: 100%;
              height: 520px;
            }
          }

          >h2 {
            width: 100%;
            // height: 22px;
            font-size: 22px;
            color: #ffffff;
            line-height: 120px;
            // margin: 0;
          }

          .news_desc {
            width: 100%;
            max-height: 120px;
            font-size: 20px;
            color: #cccccc;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 120px;
          }

          >span {
            font-size: 16px;
            color: #ffffff;
            line-height: 120px;
          }
        }
      }
    }

    .news_notice {
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;

      .notice_list_wrap {
        width: 100vw;
        padding: 0px 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .notice_item_card {
          display: flex;
          flex-direction: column;
          margin-bottom: 89px;
          width: 46vw;

          .notice_img {
            width: 100%;
            height: 520px;
            margin-bottom: 26px;
            position: relative;

            >img {
              width: 100%;
              height: 520px;
            }

            >div {
              visibility: hidden;
              position: absolute;
              width: 470px;
              height: 260px;
              background: rgba($color: #000000, $alpha: 0.5);
              display: flex;
              flex-direction: column;
              justify-content: center;

              >i {
                color: #fff;
                font-size: 50px;
                margin: 0 auto;
              }
            }
          }

          .notice_img:hover {
            >div {
              visibility: visible;
            }
          }

          >h2 {
            width: 100%;
            // height: 22px;
            line-height: 120px;
            font-size: 22px;
            color: #ffffff;
            margin: 0;
          }

          .notice_desc {
            width: 358px;
            max-height: 120px;
            font-size: 20px;
            color: #cccccc;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            line-height: 40px;
          }

          >span {
            // width: 81px;
            // height: 12px;
            line-height: 120px;
            font-size: 16px;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>

<style>
.news-container .el-breadcrumb__item .el-breadcrumb__inner {
  color: rgba(255, 255, 255, 0.8) !important;
}

.text-in {
  text-indent: 2em;
}

.bold {
  font-weight: bold;
}

.lh-60 {
  line-height: 100px !important;
}

.download {
  text-decoration: underline;
  color: #fff;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// index.vue?41f6bab6